import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import withAuth from '../../../HOC/withAuth';
import { useTranslation } from '../../../t';
import Empty from '../../../components/Empty';
import CustomPagination from '../../../components/Pagination';
import dayjs from 'dayjs';
import InfoBar from '../InfoBar';
import C from '../../../colors';
import { formatMoney } from '../../../money';

const SubscriptionIndex = inject('userStore')(observer(({ userStore }) => {
  const { t } = useTranslation();
  const [bookings, setBookings] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  useEffect(() => {
    userStore.fetchSubscriptions(page).then(data => {
      setBookings(data.bookings);
      const total = data.pagination?.totalItems ?? data.total ?? data.bookings?.length;
      setTotalPage(data.pagination?.totalPages || data.totalPage || Math.ceil(total / 10) || 1);
    });
  }, [page]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <InfoBar />
      <div style={{ flex: 1, overflow: 'auto', padding: '28px 36px' }}>
        <h1 style={{ margin: '0 0 24px', fontFamily: C.serif, fontSize: 36, fontWeight: 400, color: C.ink }}>{t('Subscriptions List')}</h1>

        {bookings.length === 0 ? (
          <Empty message={t('No subscriptions')}/>
        ) : (
          <div style={{ background: '#fff', border: `1px solid ${C.hair}`, borderRadius: 14, overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: C.sans }}>
              <thead>
                <tr style={{ borderBottom: `1px solid ${C.hair}`, background: C.paper2 }}>
                  {[t('Order Number'), t('Amount'), t('Status'), t('Subscription Time'), t('Duration')].map(h => (
                    <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 600, color: C.ink3, fontFamily: C.mono, textTransform: 'uppercase', letterSpacing: 1 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {bookings.map((b, i) => (
                  <tr key={b.id || i} data-testid={`subscription-record-${b.id}`} style={{ borderBottom: i < bookings.length - 1 ? `1px solid ${C.hair}` : 'none' }}>
                    <td style={{ padding: '14px 16px', fontSize: 13, color: C.ink, fontFamily: C.mono }}>{b.orderNo || b.id}</td>
                    <td style={{ padding: '14px 16px', fontSize: 13, color: C.ink }}>¥{formatMoney(b.amount)}</td>
                    <td style={{ padding: '14px 16px' }}>
                      <span style={{ padding: '3px 8px', borderRadius: 10, fontSize: 11, fontWeight: 600, background: b.status === 'completed' ? C.successBg : C.warningBg, color: b.status === 'completed' ? C.successFg : C.warningFg }}>
                        {t(b.status || 'pending')}
                      </span>
                    </td>
                    <td style={{ padding: '14px 16px', fontSize: 13, color: C.ink2 }}>{b.createdAt ? dayjs(b.createdAt).format('YYYY-MM-DD HH:mm') : '—'}</td>
                    <td style={{ padding: '14px 16px', fontSize: 13, color: C.ink2 }}>{b.duration ? `${b.duration} ${t('Month')}` : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {totalPage > 1 && (
          <div style={{ marginTop: 16 }}>
            <CustomPagination count={totalPage} page={page} onChange={(_, v) => setPage(v)}/>
          </div>
        )}
      </div>
    </div>
  );
}));

export default withAuth(SubscriptionIndex);
